<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="h1" id="pt1"><span aria-label=" Page 5 . " epub:type="pagebreak" id="pg_5" role="doc-pagebreak"><samp>Part I</samp></span></h1>
<figure class="IMG"><img alt="image" class="img02" src="images/pg14.jpg"/></figure>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?6b0055a4